import type { IOrderConfirmResponseDto } from '@/shared/api/subscriptions';

export const CHANNELS_ROUTE = '/channels';

type PaymentRedirectResponse = IOrderConfirmResponseDto & {
  paymentUrl?: string;
  payment_url?: string;
  payment_link?: string;
};

export function isHttpsPaymentLink(link: string | null | undefined): link is string {
  try {
    return new URL(link ?? '').protocol === 'https:';
  } catch {
    return false;
  }
}

// subscription-service /confirm substitutes this exact same-origin app route
// for trial activations (no external payment URL) — it must keep flowing
// through the redirect path, while every other non-https value is blocked.
function isSafePaymentLink(link: string): boolean {
  return isHttpsPaymentLink(link) || link === CHANNELS_ROUTE;
}

export function getPaymentRedirectLink(response: PaymentRedirectResponse) {
  const link = (
    response.paymentLink ||
    response.paymentUrl ||
    response.payment_url ||
    response.payment_link ||
    ''
  );
  // Defense in depth: the link comes from our own backend, but a compromised
  // or buggy response must never become a javascript:/data: navigation.
  if (link && !isSafePaymentLink(link)) {
    console.warn('paymentRedirect: blocked non-https payment link');
    return '';
  }
  return link;
}

export function reservePaymentTab() {
  const paymentWindow = window.open('about:blank', '_blank');
  if (!paymentWindow) return null;

  paymentWindow.opener = null;
  paymentWindow.document.title = 'GOCHAT';
  paymentWindow.document.body.textContent = 'Открываем счет...';

  return paymentWindow;
}

export function openReservedPaymentTab(
  paymentLink: string,
  paymentWindow: Window | null
) {
  if (!isSafePaymentLink(paymentLink)) {
    console.warn('paymentRedirect: blocked non-https payment tab navigation');
    return false;
  }

  try {
    if (paymentWindow && !paymentWindow.closed) {
      paymentWindow.location.href = paymentLink;
      return true;
    }

    const newPaymentWindow = window.open(paymentLink, '_blank');
    if (!newPaymentWindow) return false;

    newPaymentWindow.opener = null;

    return true;
  } catch {
    return false;
  }
}

export function navigateToChannels() {
  if (window.location.pathname !== CHANNELS_ROUTE) {
    window.location.assign(CHANNELS_ROUTE);
  }
}
